<template>
  <div>
    <div v-if="get_absen_loading" class="loading-container">
      <div class="loader"></div>
    </div>
    
    <div v-if="!get_absen_loading">
      <!-- Header -->
      <div class="flex justify-between items-center border-b border-gray-100 px-5 pt-3 pb-3 m-0">
        <div class="flex-grow">
          <p class="playfair-display-400 text-base p-0 m-0">Bulan {{ $route.params.id | bulan }}</p>
        </div>
      </div>

      <!-- Attendance List -->
      <div class="attendance-list">
        <div v-for="(item, index) in paginatedData" :key="index" class="attendance-item">
          <div class="item-row">
            <div class="employee-section">
              <span class="employee-name">{{ item?.nama }}</span>
              <span class="date-text">{{ item?.tanggal | konversi_tanggal }}</span>
            </div>
            
            <div class="time-section">
              {{ item?.absenMasukSitkp | konversi_waktu }} - {{ item?.absenPulangSitkp | konversi_waktu }}
            </div>
            
            <div class="progress-section">
              {{ item?.progres == null ? 0 : item?.progres }}%
            </div>
            
            <div class="action-section">
              <button class="detail-btn" @click="open_dialogvisible(item)">
                Detail
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Pagination -->
      <div class="pagination-wrapper">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="itemsPerPage"
          layout="prev, pager, next, jumper, total"
          :total="filteredAbsen.length">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="Detail" :visible.sync="dialogvisible" width="50%">
      <div>
        <div class="flex justify-between items-center border-b border-gray-100 px-0 pt-0 pb-2.5 m-0">
          <div class="flex-grow">
            <p class="text-gray-600 text-xs text-left roboto-light p-0 m-0">{{ absen.tanggal | konversi_tanggal }}</p>
            <p class="titillium-web-regular p-0 m-0">{{ absen.nama }}</p>
          </div>
          <div class="w-44">
            <p class="text-gray-600 text-sm text-left roboto-light p-0 m-0">{{ absen.absenMasukSitkp | konversi_waktu }} - {{ absen.absenPulangSitkp | konversi_waktu }}</p> 
          </div>
          <div class="w-44 ml-4">
            <p class="text-gray-600 text-sm text-right roboto-light p-0 m-0">Progress {{ absen.progres == null ? 0 : absen.progres }}%</p> 
          </div>
        </div>
        <div class="px-0 pt-2.5 pb-2.5 m-0">
          <el-row>
            <el-col :span="3">
              <p class="text-gray-600 text-sm roboto-light p-0 m-0">Kegiatan</p>
            </el-col>
            <el-col :span="21">
              <p class="text-gray-400 text-sm text-justify roboto-light p-0 m-0">{{ absen.kegiatan == null ? 'Belum ada kegiatan' : absen.kegiatan }}</p>
            </el-col>
          </el-row>
          <el-row class="mt-2">
            <el-col :span="3">
              <p class="text-gray-600 text-sm roboto-light p-0 m-0">Output</p>
            </el-col>
            <el-col :span="21">
              <p class="text-gray-400 text-sm text-justify roboto-light p-0 m-0">{{ absen.output == null ? 'Belum ada output' : absen.output | format_output }}</p>
            </el-col>
          </el-row>
          <el-row class="mt-2">
            <el-col :span="3">
              <p class="text-gray-600 text-sm roboto-light p-0 m-0">Evidence</p>
            </el-col>
            <el-col :span="21">
              <p class="text-gray-400 text-sm text-justify roboto-light p-0 m-0">{{ absen.output == null ? 'Belum ada evidence' : absen.output | format_evidence }}</p>
            </el-col>
          </el-row>
        </div>
        <div>
          <l-map v-if="showMap" :zoom="zoom" :center="absen.koordinat_masuk" :options="mapOptions" @update:center="centerUpdate" @update:zoom="zoomUpdate" style="height:400px;width:100%;">
            <l-tile-layer :url="url" :attribution="attribution" />
            <l-marker :lat-lng="absen.koordinat_masuk" v-if="absen.latitude != null && absen.longitude != null">
              <l-popup class="p-0 m-0">
                <div class="font-1">Absen Masuk</div>
              </l-popup>
            </l-marker>
            <l-marker :lat-lng="absen.koordinat_siang" v-if="absen.latitudeSiang != null && absen.longitudeSiang != null">
              <l-popup class="p-0 m-0">
                <div class="font-1">Absen Siang</div>
              </l-popup>
            </l-marker>
            <l-marker :lat-lng="absen.koordinat_pulang" v-if="absen.latitudePulang != null && absen.longitudePulang != null">
              <l-popup class="p-0 m-0">
                <div class="font-1">Absen Pulang</div>
              </l-popup>
            </l-marker>
          </l-map>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogvisible = false">Cancel</el-button> -->
        <!-- <el-button type="primary" @click="dialogvisible = false">Confirm</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import ingredient from "@/assets/json/ingredient.json";

import { latLng, Icon } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});
export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup
  },
  data() {
    return {
      zoom: 13,
      center: latLng(47.41322, -1.219482),
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      withPopup: latLng(47.41322, -1.219482),
      withTooltip: latLng(47.41422, -1.250482),
      currentZoom: 11.5,
      currentCenter: latLng(47.41322, -1.219482),
      showParagraph: false,
      mapOptions: { zoomSnap: 0.5 },
      showMap: true,
      tanggal: new Date(),
      bulan: moment(new Date()).format("M"),
      tahun: moment(new Date()).format("YYYY"),
      absen: {},
      dialogvisible: false,
      currentPage: 1,
      itemsPerPage: 10
    }
  },
  filters: {
    bulan: function(value) {
      let nama_bulan = ingredient.bulan;
      return nama_bulan[value - 1];
    },
    konversi_tanggal: function(value){
      moment.locale('id'); 
      return moment(value).format('dddd')+', '+moment(value).format('LL');
    },
    konversi_waktu: function(value){
      moment.locale('id'); 
      return value === null ? 'Belum Absen' : moment(value).format('HH.mm');
    },
    format_output: function(value) {
      if (value != null) {
        let abc = value.split("@");
        return abc[0];
      }
      return "Belum ada";
    },
    format_evidence: function(value) {
      if (value != null) {
        let abc = value.split("@");
        return abc[1];
      }
      return "Belum ada";
    },
  },
  computed: {
    get_absen() {
      return this.$store.state.absen.absen
    },
    get_absen_loading() {
      return this.$store.state.absen.loading
    },
    filteredAbsen() {
      return this.get_absen.filter(item => 
        item?.bulan == this.$route.params.id && item?.tahun == this.tahun
      )
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.itemsPerPage
      const end = start + this.itemsPerPage
      return this.filteredAbsen.slice(start, end)
    }
  },
  created() {
    this.$store.dispatch('absen/get_per_bulan')
  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    open_dialogvisible: function(value) {
      this.dialogvisible = true;
      this.absen = value;
    },
    handleCurrentChange(page) {
      this.currentPage = page;
    }
  }
}
</script>

<style scoped>
/* Loading styles */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.loader {
  border: 4px solid #f3f4f6;
  border-top: 4px solid #3b82f6;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Simple list styles */
.attendance-list {
  padding: 16px;
  max-width: 900px;
  margin: 0 auto;
}

.attendance-item {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  margin-bottom: 8px;
  transition: all 0.2s ease;
}

.attendance-item:hover {
  border-color: #3b82f6;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1);
}

.item-row {
  display: flex;
  align-items: center;
  padding: 16px;
  gap: 16px;
}

.employee-section {
  flex: 2;
  min-width: 0;
}

.employee-name {
  display: block;
  font-weight: 600;
  color: #1f2937;
  font-size: 14px;
  margin-bottom: 4px;
}

.date-text {
  display: block;
  color: #6b7280;
  font-size: 12px;
}

.time-section {
  flex: 1;
  color: #374151;
  font-size: 13px;
  text-align: left;
}

.progress-section {
  text-align: left;
  color: #059669;
  font-weight: 600;
  font-size: 12px;
  min-width: 60px;
}

.action-section {
  text-align: right;
  min-width: 80px;
}

.detail-btn {
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.detail-btn:hover {
  background: #2563eb;
}

/* Simple pagination */
.pagination-wrapper {
  display: flex;
  justify-content: center;
  /* margin: 24px 0; */
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .item-row {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    padding: 12px;
  }
  
  .employee-section {
    text-align: left;
  }
  
  .time-section {
    text-align: left;
    font-size: 13px;
  }
  
  .progress-section {
    text-align: left;
  }
  
  .detail-btn {
    width: 100%;
    padding: 10px;
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .employee-name {
    font-size: 14px;
  }
  
  .date-text {
    font-size: 11px;
  }
  
  .time-section {
    font-size: 12px;
  }
  
  .progress-section {
    font-size: 12px;
  }
}

/* Simple fade animation */
.attendance-item {
  animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>